const PROD_ORG_ID = "fc2718d4-537d-41a9-a577-bfec971198b1";
const QA_ORG_ID = "913a5ac9-4743-4850-8920-0d48e2bdeeca";

function getVoltaireUrl() {
  const isQa = window.location.hostname === "qa.guidewire.voltaireclaims.com";
  const appHost = isQa ? "qa-app.voltaire.claims" : "app.voltaire.claims";
  const orgId = isQa ? QA_ORG_ID : PROD_ORG_ID;

  return `https://${appHost}/integration/${orgId}/letters/new-letter?ClaimNumber=Demo`;
}

export function VoltairePage() {
  return (
    <iframe
      src={getVoltaireUrl()}
      title="Voltaire"
      style={{
        border: "none",
        width: "100%",
        height: "100%",
        display: "block",
      }}
    />
  );
}
